import { Box, styled } from "@mui/material";

export const ContentModal = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  maxWidth: "660px",
  backgroundColor: theme.palette.background.default,
  maxHeight: "95vh",
  overflowY: "auto",
  overflowX: "hidden",
}));
